import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Typography, Link, Tab } from '@mui/material';
import { WorklistItem } from '@components';
import { useAllWorklist } from './hooks/useAllWorklist';
import { AddTask } from '@components';
import { AllWorklistContext } from './contexts/AllWorklistContext';
import { ArrowBack } from '@mui/icons-material';

import { theme } from '@store';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import {
  Incomplete,
  Completed,
} from 'views/pages/Worklist/AllWorklist/components';

export const AllWorklist = () => {
  const {
    filters,
    handleFilterChange,
    selectedTaskId,
    handleCloseDrawer,
    handleOpenTaskDetails,
    handleBack,
    appliedFiltersCount,
    handleChangeTabIndex,
    completedFilters,
    handleCompletedFilterChange,
    tabIndex,
    handleFullResetCompletedFilters,
    handleFullResetIncompleteFilters,
    isFiltersCardOpen,
    handleCloseFiltersCard,
    handleToggleFiltersCard,
  } = useAllWorklist();

  const contextValues = {
    filters,
    handleFilterChange,
    selectedTaskId,
    handleCloseDrawer,
    handleOpenTaskDetails,
    appliedFiltersCount,
    completedFilters,
    handleCompletedFilterChange,
    handleFullResetCompletedFilters,
    handleFullResetIncompleteFilters,
    isFiltersCardOpen,
    handleCloseFiltersCard,
    handleToggleFiltersCard,
  };

  return (
    <AllWorklistContext.Provider value={contextValues}>
      <Box
        sx={{
          [theme.breakpoints.down('md')]: {
            display: 'none',
          },
          width: 'fit-content',
        }}
      >
        <Link
          component={'button'}
          onClick={handleBack}
          underline='always'
          sx={{
            display: 'flex',
            justifyContent: 'start',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          <ArrowBackIcon sx={{ fontSize: '1.3rem' }} color='primary' />
          <Typography sx={{ color: 'primary' }}>
            Back to previous page
          </Typography>
        </Link>
      </Box>
      <Box
        sx={{
          paddingTop: '1rem',
          gap: '1rem',
          display: 'flex',
          flexDirection: 'column',
          pb: '1rem',
        }}
      >
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
            <Box
              sx={{
                [theme.breakpoints.up('md')]: {
                  display: 'none',
                },
                width: 'fit-content',
              }}
            >
              <Link
                component={'button'}
                onClick={handleBack}
                underline='always'
                sx={{
                  display: 'flex',
                  justifyContent: 'start',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                <ArrowBack sx={{ fontSize: '2rem' }} color='primary' />
              </Link>
            </Box>
            <Typography variant='h4'>All Tasks</Typography>
          </Box>
          <AddTask />
        </Box>
      </Box>

      <TabContext value={tabIndex}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={handleChangeTabIndex}>
            <Tab label='INCOMPLETE' value='incomplete' />
            <Tab label='COMPLETED' value='completed' />
          </TabList>
        </Box>

        <TabPanel value='incomplete'>
          <Incomplete />
        </TabPanel>
        <TabPanel value='completed'>
          <Completed />
        </TabPanel>
      </TabContext>
      {selectedTaskId && (
        <WorklistItem
          open={!!selectedTaskId}
          itemId={selectedTaskId}
          handleClose={handleCloseDrawer}
        />
      )}
    </AllWorklistContext.Provider>
  );
};
